import { getterTypes } from './types';

const getters = {
  [getterTypes.GET_SCHOOLS]: (state) => state.schools,
  [getterTypes.GET_SCHOOL_TYPES]: (state) => state.schoolTypes,
  [getterTypes.GET_MUNICIPALITIES]: (state) => state.municipalities,
  [getterTypes.GET_RLVTYPES]: (state) => state.rlvTypes,
  [getterTypes.GET_SCHOOL_INFORMATION]: (state) => state.schoolInformation,
  [getterTypes.GET_RESULTS]: (state) => state.results,
  [getterTypes.GET_PAGINATION]: (state) => state.pagination,
  [getterTypes.GET_FILTER]: (state) => state.filter,
};

export default getters;
